import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useLang from "../hooks/useLang";
import LanguageSwitcher from "../components/LanguageSwitcher";
import Logo from "../components/Logo";
import api from "../api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) {
      toast.error(t("passwordsDontMatch"));
      return;
    }
    if (pw.length < 6) {
      toast.error("Password min 6 caratteri");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(t("resetSuccess"));
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || t("errorGeneric"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col dot-grid">
      <div className="flex justify-end p-6"><LanguageSwitcher small /></div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm animate-fade-up">
          <div className="flex flex-col items-center mb-10"><Logo size="md" /></div>
          <div className="bg-white border border-zinc-200 rounded-md p-8">
            <div className="overline mb-3">/// Reset</div>
            <h2 className="font-heading text-2xl tracking-tight mb-1">{t("resetPasswordTitle")}</h2>
            <p className="text-zinc-500 text-sm mb-8">{t("resetPasswordSubtitle")}</p>
            {!token ? (
              <p className="text-sm text-red-600">Token mancante</p>
            ) : (
              <form onSubmit={submit} className="space-y-5">
                <div className="space-y-2">
                  <Label className="overline">{t("newPassword")}</Label>
                  <Input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-pw-input" className="rounded-md border-zinc-200 h-11" />
                </div>
                <div className="space-y-2">
                  <Label className="overline">{t("confirmPassword")}</Label>
                  <Input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-pw2-input" className="rounded-md border-zinc-200 h-11" />
                </div>
                <Button type="submit" disabled={loading} data-testid="reset-submit-btn" className="w-full h-11 bg-zinc-950 hover:bg-zinc-800 rounded-md font-medium">
                  {loading ? t("loading") : t("save")}
                </Button>
              </form>
            )}
          </div>
          <Link to="/login" className="block text-center text-sm text-zinc-500 hover:text-zinc-950 mt-6">{t("login")}</Link>
        </div>
      </div>
    </div>
  );
}
